<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-18 11:57:55
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-19 15:51:36
 * @FilePath: \合联\oms\src\view\workOrderManagement\workOrderType\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis, upload } from "@/api/workOrderManagement/workOrderType";
export default {
  name: "",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
        upload,
        beforeHandleList({ data }) {
          return data;
        },
      },
      config: {
        rowId: "id",
        treeConfig: {
          children: "child",
          // expandAll: true,
          accordion: true,
          reserve: true,
        },
      },
      footer: {
        show: () => false,
      },
      modals: {
        add: {
          type: "add",
          methods: {
            open() {
              let formData = this.getFormData();
              if (formData.src) {
                formData.src = {
                  src: formData.src,
                  preview: true,
                  name: this.$tz("附件"),
                };
              }
            },
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id, pid: row.pid });
              if (data.src) data.src = data.src.src;
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ pname: 24 }, { title: 24 }, { message: 24 }, { src: 24 }],
          fields: [
            {
              name: () => this.$tz("父级,名称"),
              key: "pname",
              component: "Input",
              disabled: true,
              show() {
                return this.formData.pid;
              },
              placeholder: () => this.$tz("父级,名称"),
            },
            {
              name: () => this.$tz("类型,名称"),
              key: "title",
              component: "Input",
              placeholder: () => this.$tz("类型,名称"),
            },
            {
              name: () => this.$tz("回复,内容"),
              key: "message",
              component: "Input",
              placeholder: () => this.$tz("回复,内容"),
            },
            {
              name: () => this.$tz("附件"),
              key: "src",
              component: "Upload",
              bind: {
                isButton: true,
                fileName: "changeFile",
                multiple: false,
              },
              methods: {
                beforeUpload: ({ file, row }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let _this = this.$refs["table"];
                  _this
                    .handleRequestMethods("upload", formData, true, true)
                    .then((res) => {
                      row.src = res.payload;
                      this.$refs["table"].getModal("add").setFormData({
                        src: {
                          preview: true,
                          src: res.payload,
                          name: file.name,
                        },
                      });
                    });
                  return false;
                },
              },
            },
          ],
        },
      },
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              id: 1855,
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open({}, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$tz("类型,名称"),
          key: "title",
          minWidth: 110,
          columnBind: {
            "tree-node": true,
          },
        },
        {
          name: () => this.$tz("回复,内容"),
          key: "message",
          minWidth: 110,
        },
        {
          name: () => this.$tz("附件"),
          key: "src",
          width: 110,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          disabled({ row }) {
            return !row.src;
          },
          methods: {
            click({ row }) {
              window.open(this.$globalUrl + row.src, "_blank");
            },
            render() {
              return this.$tz("查看");
            },
          },
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("更新"),
              type: "edit",
              fnName: "edit",
              id: 1855,
              bind: {
                type: "primary",
              },
              id: "",
            },
            {
              name: () => "+ " + this.$tz("子级"),
              type: "add",
              fnName: "add",
              id: 1855,
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$tz("删除"),
              type: "del",
              fnName: "del",
              id: 1854,
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            edit({ row }) {
              this.getModal("add").open(row, function () {
                this.setTitle(this.$tz("更新"));
              });
            },
            add({ row }) {
              this.getModal("add").open(
                {
                  pid: row.id,
                  pname: row.title,
                },
                function () {
                  this.setTitle("+ " + this.$tz("子级"));
                }
              );
            },
            del({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>